var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContentAddSpaceOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.588 19.413C2.979 19.804 3.45 20 4 20h9v-2H4V8h16v5h2V8c0-.55-.196-1.02-.587-1.412A1.927 1.927 0 0020 6h-8l-2-2H4c-.55 0-1.02.196-1.412.588A1.923 1.923 0 002 6v12c0 .55.196 1.021.588 1.413z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 23h2v-3h3v-2h-3v-3h-2v3h-3v2h3v3z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContentAddSpaceOutline);
export default __webpack_public_path__ + "d8a408ecc21b888446255a0133a9a572.svg";
export { ForwardRef as ReactComponent };